// useDialogManager.js
import { useState } from "react";

export function useDialogManager() {
  const [openDialog, setOpenDialog] = useState(null);
  const [data, setData] = useState(null);

  const open = (dialogName, dialogData = null) => {
    setOpenDialog(dialogName);
    setData(dialogData);
  };

  const close = () => {
    setOpenDialog(null);
    setData(null);
  };

  return { openDialog, data, open, closeDialog: close };
}
